import React, { FC } from 'react';
import { FlowContextProvider } from 'context/FlowProvider';
import { DesignContextProvider } from 'context/DesignProvider';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { getI18n } from '@wix/gg-common-lib/utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppLayout } from './AppLayout';
import { NotificationProvider } from '@wix/gg-components';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  },
});

const i18n = getI18n(window.__LANGUAGE__, window.__MESSAGES__, require('../../assets/locales/messages_en.json'));

export const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <DesignContextProvider>
          <NotificationProvider>
            <FlowContextProvider>
              <AppLayout />
            </FlowContextProvider>
          </NotificationProvider>
        </DesignContextProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
};
